import PropTypes from 'prop-types'

export const InputType = {
  Text: 'text',
  Select: 'select',
  Checkbox: 'checkbox',
}
export const COMMON_FORM_FIELD_PROPS = {
  /** Form field can contain different types of inputs */
  inputType: PropTypes.oneOf([
    InputType.Text,
    InputType.Select,
    InputType.Checkbox,
  ]),
  /** A unique DOM Element ID */
  id: PropTypes.string,
  /** A label for the form field */
  label: PropTypes.node,
  /** A text input can have an additional label attached to the left of the input box */
  attachedLabel: PropTypes.string,
  /** For use with input type 'select', options for the dropdown */
  options: PropTypes.arrayOf(PropTypes.exact({
    value: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  })),
  /** An input can show a placeholder value */
  placeholder: PropTypes.string,
  /** A form field can render helper text under the input */
  detail: PropTypes.node,
  /** A text input can have a maximum input lenght */
  maxLength: PropTypes.number,
  /** A text input can have a minimum input lenght */
  minLength: PropTypes.number,
  /** A form field can have additional CSS classes applied */
  className: PropTypes.string,
  /** A function that transforms the value prior to calling the onChange function */
  transform: PropTypes.func,
}

export const FORM_FIELD_CONTROL_PROPS = {
  /** A form field should call an additional function when the input changes */
  onChange: PropTypes.func.isRequired,
  /** A form field can call an additional function when the input is blurred */
  onBlur: PropTypes.func,
  /** A form field's input should have a value */
  value: PropTypes.any.isRequired,
  /** An input can display an error message below */
  error: PropTypes.node,
  /** A form field can call an additional function when the input is focused */
  onFocus: PropTypes.func,
  /** A form field can opt to display a specific value instead of the input's actual `value` */
  viewValue: PropTypes.any
}

export const ADDITIONAL_FORM_FIELD_PROPS = {
  /**
   * A form field can be invalid, highlighting the field as such.
   * This is distinct from the error prop, so we can highlight an invalid field without helper text if necessary.
   * */
  invalid: PropTypes.bool,
  /** An input can be disabled */
  disabled: PropTypes.bool,
  /** Additional detail can be shown when the label is hovered */
  hoverDetail: PropTypes.string,
  /** A form field's input can be masked ( i.e, a phone number: (000) - 123 -2340 ) */
  maskOptions: PropTypes.exact({
    isNumber: PropTypes.bool,
    maskOnSubmit: PropTypes.bool,
    pattern: PropTypes.string,
    additionalProps: PropTypes.object
  })
}